
import { Inject, Injectable } from '@angular/core';
import { ApiCommonService, TimeApiService } from 'cbc-shared-lib';
import { Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { Sgke361aRequest, Sgke361aResponse, Sgke361aService } from 'sg-api';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';
import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';

@Injectable({
  providedIn: 'root'
})
export class UsedSgke361aService {

  /**
   * コンストラクタ
   * @param {Sgke361aService} service
   * @param {ApiCommonService} apiCommonService
   * @param {TimeApiService} timeApiService
   * @param {FeaturesLibConfig} featuresLibcComfig
   * @memberof UsedSgke361aService
   */
  constructor(
    public service: Sgke361aService,
    public apiCommonService: ApiCommonService,
    private timeApiService: TimeApiService,
    @Inject(FEATURES_LIB_CONFIG) private featuresLibcComfig: FeaturesLibConfig
  ) { }
  /**
   * SGKE361A_供給再開結果初期表示API呼び出し
   * @param {Sgke361aRequest} request 
   * @returns {Observable<Sgke361aResponse>}
   * @memberof UsedSgke361aService
   */
  public doSgke361a(request: Sgke361aRequest): Observable<Sgke361aResponse> {
    //日付のフォーマットをYYMMDDに変更
    this.apiCommonService.convertElementInObject(request, Object.prototype.toString.call(new Date()), this.timeApiService.convertDateToString);
    return this.service.SGKE361APost(this.apiCommonService.setRequestCommon(<any>request), 'response')
      .pipe(
        map(
          response => {
            // エラーが設定されていないかチェックする
            this.apiCommonService.checkError(response);
            return response.body;
          }),
        timeout(Number(this.featuresLibcComfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, 'bill', 'SGKE361A');
          return throwError(err.message);
        })
      );
  }
}
